import { useMemo } from 'react';
import { Box, Tag, TagCloseButton } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';
import EyeHideIcon from 'components/icons/EyeHideIcon';

const baseBadgeStyle = {
  color: 'brand.black',
  padding: '4px 8px',
  fontWeight: '600',
  fontSize: '13px',
  textTransform: 'capitalize',
};

const filterBadgeStyle = {
  ...baseBadgeStyle,
  backgroundColor: 'brand.light-green',
};

const exclusionBadgeStyle = {
  ...baseBadgeStyle,
  backgroundColor: 'brand.tangerine.500',
};

const hideIconStyle = {
  marginRight: (theme: any) => theme.space.eight,
};

enum BadgeTypes {
  Filter,
  Exclusion,
}

type TStatusBadge = {
  label: string;
  type?: BadgeTypes;
  onRemove: any;
};

const FilterBadge = ({ label, type = BadgeTypes.Filter, onRemove }: TStatusBadge) => {
  const tagStyle = useMemo(() => {
    return type === BadgeTypes.Filter ? filterBadgeStyle : exclusionBadgeStyle;
  }, [type]);

  return (
    <Tag key={label} sx={tagStyle}>
      {type === BadgeTypes.Exclusion && (
        <Box as="span" sx={hideIconStyle}>
          <EyeHideIcon width={14} height={14} stroke={Colors.Tangerine700} />
        </Box>
      )}
      {label}
      <TagCloseButton
        onClick={() => {
          onRemove(label);
        }}
      />
    </Tag>
  );
};

FilterBadge.BadgeTypes = BadgeTypes;

export default FilterBadge;
